"use client";

import PropTypes from "prop-types";

import SalePanel from "components/homepage/showcase-tab-panels/sale-panel";
import RentPanel from "components/homepage/showcase-tab-panels/rent-panel";
import ListingIdPanel from "components/homepage/showcase-tab-panels/listing-id-panel";
import EstateOfficePanel from "components/homepage/showcase-tab-panels/estate-office-panel";
import ProjectsPanel from "components/homepage/showcase-tab-panels/projects-panel";

import { getSaleCategories } from "@/src/helpers/extract-category-childs";
import { Tab } from "@headlessui/react";

import styles from "./styles.module.css";

const ShowcaseTabWrapper = ({ categoryTree }) => {
  const categories = ["Satılık", "Kiralık", "Projeler", "Emlak Ofisleri", "İlan No"];

  const saleCategories = getSaleCategories({
    data: categoryTree,
    categoryToExtract: "Satılık",
  });

  const rentCategories = categoryTree?.find((item) => item?.name === "Kiralık");
  const projectCategories = categoryTree?.find((item) => item?.name === "Projeler");

  return (
    <div className={styles.wfull}>
      <Tab.Group>
        <Tab.List>
          {categories.map((category) => (
            <Tab
              key={category}
              className={({ selected }) => `${styles.tab} ${selected ? styles.tabselected : styles.tabnotselected}`}
            >
              {category}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          <Tab.Panel className={styles.tabpanel}>
            <SalePanel saleCategories={saleCategories} />
          </Tab.Panel>
          <Tab.Panel className={styles.tabpanel}>
            <RentPanel rentCategories={rentCategories} />
          </Tab.Panel>
          <Tab.Panel className={styles.tabpanel}>
            <ProjectsPanel projectCategories={projectCategories} />
          </Tab.Panel>
          <Tab.Panel className={styles.tabpanel}>
            <EstateOfficePanel />
          </Tab.Panel>
          <Tab.Panel className={styles.tabpanel}>
            <ListingIdPanel />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

ShowcaseTabWrapper.propTypes = {
  categoryTree: PropTypes.any,
};

export default ShowcaseTabWrapper;
